import React from 'react';
import aldoLogoSvg from "./home/images/Aldo.svg";


export const AldoLogo = () => {
    return <div className={"d-flex px-3"}>
        <img src={aldoLogoSvg} alt="" style={{ width: "10rem" }} />
    </div>
}
